import React from 'react';
import { WithDefaultLayout } from '../components/DefautLayout';
import { Title } from '../components/Title';
import ContactUsLms from '@/components/lms/LmsContactUs';
import CardEkskul from '@/components/ekskul/About-Card-Ekskul';
import SectionLanding from '@/components/ekskul/SectionLanding';
import CodingSoftwareSection from '@/components/ekskul/CodingSoftwareSection';

const EkskulIndexPage = () => {
    return (
        <div>
            <Title title={'Ekskul'} description='' />
            <div>
                <section>
                    <SectionLanding />
                </section>

                <section>
                    <CodingSoftwareSection />
                </section>

                <section className="overflow-x-hidden">
                    <div>
                        <div className='flex flex-col mx-auto items-center mb-4 md:mb-4 -mt-2'>
                            <h2 className="text-slate-900 text-4xl font-body font-semibold text-center mt-10">Ruang Lingkup</h2>
                            <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mt-3 md:mt-5' />
                            <CardEkskul />
                        </div>
                    </div>
                </section>
                <section className='bg-section-ekskul'>
                    <div className="flex flex-col flex-wrap px-5 md:px-16">
                        <div className="flex flex-col mx-auto text-center mb-8 md:mb-8 items-center mt-8">
                            <h2 className='text-white text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed mb-2'>Yuk Konsultasi Lebih Lanjut!</h2>
                            <ContactUsLms useCustomStyles={false} />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
EkskulIndexPage.layout = WithDefaultLayout
export default EkskulIndexPage